import { render, staticRenderFns } from "./SentDocuments.vue?vue&type=template&id=65251de2"
import script from "./SentDocuments.vue?vue&type=script&lang=js"
export * from "./SentDocuments.vue?vue&type=script&lang=js"
import style0 from "./SentDocuments.vue?vue&type=style&index=0&id=65251de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports